import {
    API_REQUEST,
    VALIDATE_MASQUERADE
} from "../../actionTypes/actionsTypes";
import { AppAction } from "../../types";

export const initMasquerade = (userProfileId: string, token: string): AppAction => ({
    type: API_REQUEST,
    payload: {
        url: `/masquerade/${userProfileId}`,
        next: VALIDATE_MASQUERADE,
        method: 'GET',
        authorization: token
    }
});